export default __webpack_public_path__ + "static/blog-default-eb034b9d0e7af00f448c7a5491f4ff4c.jpg";